import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * ConfirmModal - Styled confirmation dialog
 * @param {boolean} show - Control visibility
 * @param {function} onHide - Callback when modal closes (cancel)
 * @param {function} onConfirm - Callback when user confirms
 * @param {string} title - Modal title
 * @param {string} message - Confirmation message
 * @param {string} confirmText - Text for confirm button (default: "Confirm")
 * @param {string} cancelText - Text for cancel button (default: "Cancel")
 */
const ConfirmModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  title = "Confirm Action",
  message, 
  confirmText = "Confirm",
  cancelText = "Cancel"
}) => {
  
  const handleConfirm = () => {
    onConfirm();
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={true}
      size="sm"
    >
      <Modal.Body className="text-center p-4" style={{ borderTop: '4px solid #e74c3c' }}>
        <div className="mb-3">
          <i className="fas fa-exclamation-triangle" style={{ fontSize: '3rem', color: '#e74c3c' }}></i>
        </div>
        <h5 className="mb-3">{title}</h5>
        <p className="mb-4">{message}</p>
        
        <div className="d-flex justify-content-center gap-2">
          <Button 
            variant="outline-secondary" 
            onClick={onHide}
            style={{ minWidth: '100px' }}
          >
            {cancelText}
          </Button>
          <Button 
            variant="danger" 
            onClick={handleConfirm}
            style={{ 
              minWidth: '100px',
              backgroundColor: '#e74c3c',
              borderColor: '#e74c3c'
            }}
          >
            {confirmText}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmModal;